<input class="input"
  type="text"
  readonly
  [value]="link"
/>
<capra-button
  class="button"
  data-test="copy-btn"
  text="Copy"
  [variant]="buttonVariant"
  [color]="buttonColor"
  [disabled]="disabled"
  modeClipboard
  modeTrackClick
  [clipboardText]="link"
  [trackClickData]="trackCopyClick"
></capra-button>
